var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c("v-tabs", [_c("v-tab", [_vm._v("Registrar Baja Sim")])], 1),
      _c("v-divider"),
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs4: "", sm4: "", md4: "", lg3: "" } },
                [
                  _c("DatePicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.dateStart.label,
                      required: "",
                      max: _vm.today
                    },
                    model: {
                      value: _vm.formFields.dateStart.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.dateStart, "value", $$v)
                      },
                      expression: "formFields.dateStart.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs4: "", sm4: "", md4: "", lg3: "" } },
                [
                  _c("DatePicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.dateEnd.label,
                      required: "",
                      max: _vm.today
                    },
                    model: {
                      value: _vm.formFields.dateEnd.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.dateEnd, "value", $$v)
                      },
                      expression: "formFields.dateEnd.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs4: "",
                    sm4: "",
                    md4: "",
                    lg5: "",
                    layout: "",
                    "mt-0": "",
                    "ml-3": ""
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "text-sm-center botones-filtros mt-1" },
                    [
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function($event) {
                              return _vm.filtrar()
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "#27488e" } }, [
                            _vm._v("search")
                          ]),
                          _vm._v("Filtrar\n          ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function($event) {
                              return _vm.clearFilters()
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "#27488e" } }, [
                            _vm._v("clear")
                          ]),
                          _vm._v("Limpiar")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", small: "", color: "primary" },
                          on: { click: _vm.getCSV }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _vm._v("\n              \n            "),
                          _c("span", { staticClass: "importExportBtnTexto" }, [
                            _vm._v("Exportar"),
                            _c("br"),
                            _vm._v("CSV")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs4: "", sm4: "", md4: "", lg3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.estado.label,
                      items: _vm.estados,
                      clearable: ""
                    },
                    model: {
                      value: _vm.formFields.estado.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.estado, "value", $$v)
                      },
                      expression: "formFields.estado.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs4: "", sm4: "", md4: "", lg3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.motivo.label,
                      items: _vm.motivos,
                      "item-text": "motiname",
                      "item-value": "motiid",
                      clearable: ""
                    },
                    model: {
                      value: _vm.formFields.motivo.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.motivo, "value", $$v)
                      },
                      expression: "formFields.motivo.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs4: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Buscar", clearable: "", outlined: "" },
                on: {
                  keyup: function($event) {
                    return _vm.gridApi.setQuickFilter(_vm.filtro)
                  },
                  "click:clear": function($event) {
                    return _vm.gridApi.setQuickFilter("")
                  }
                },
                model: {
                  value: _vm.filtro,
                  callback: function($$v) {
                    _vm.filtro = $$v
                  },
                  expression: "filtro"
                }
              })
            ],
            1
          ),
          _c("v-flex", {
            attrs: { xs12: "", sm6: "", md6: _vm.ProcesarSeleccion.visible }
          }),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md2: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _vm.ProcesarSeleccion.visible
                    ? _c(
                        "v-btn",
                        {
                          staticStyle: { "padding-right": "20px" },
                          attrs: { color: "#ffe800" },
                          on: {
                            click: function($event) {
                              return _vm.procesarSeleccion()
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { color: "black" },
                              attrs: { dark: "", left: "" }
                            },
                            [_vm._v("add_circle_outline")]
                          ),
                          _c("span", { staticStyle: { color: "black" } }, [
                            _vm._v("Procesar Selección")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "gridcard rounded-card solicitudBajaSimTarjeta" },
        [
          _c("MantenedorGrid", {
            staticClass: "ag-theme-material",
            attrs: {
              gridOptions: _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.showModal
        ? _c("ModalProcesar", {
            attrs: { solicitudesSelected: _vm.selecteds },
            on: {
              modalAsociacionEmit: function($event) {
                return _vm.moduloModalCallback($event)
              }
            }
          })
        : _vm._e(),
      _vm.showPopUpReport
        ? _c("PopUpGeneratedReports", {
            attrs: { text: _vm.msgReport },
            on: { cerrar: _vm.handleCloseReport }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }